import { cleanLayoutTenderTypes } from './clean-layout-tender-types'
import { cleanLayoutOrderTypes } from './clean-layout-order-types'
import { cleanLayoutStations } from './clean-layout-stations'
import _ from 'lodash'
import { cleanLayoutTabs } from 'shared-js/references/menu/layout/clean-layout-tabs'

export function cleanLayout (menuBlob, settingsBlob) {
  if (!_.has(menuBlob, 'layout')) return

  cleanLayoutTenderTypes(menuBlob.layout, settingsBlob)
  cleanLayoutOrderTypes(menuBlob.layout, settingsBlob)
  cleanLayoutStations(menuBlob.layout, settingsBlob)
  cleanLayoutTabs(menuBlob.layout, menuBlob, settingsBlob)
}
